export interface SetCustomFilterValuePayload {
  filterGroupId: string;
  filterId: string;
  optionId: string;
  enabled: boolean;
}

export class SetCustomFilterValue {
  constructor(public payload: SetCustomFilterValuePayload) {}
}
